import * as React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Box,
  ImageList,
  ImageListItem,
} from '@mui/material';
import { styled, useTheme } from '@mui/system';
import { DonutMenu, MenuItem } from './DonutMenu';

interface TextItems {
  [key: string]: {
    [key: string]: {
      title: string;
      text: string;
    };
  };
}

interface ImageItems {
  [key: string]: {
    [key: string]: {
      img: string;
      title: string;
      position: string;
    }[];
  };
}

interface IssueContentProps {
  type: 'Hotel' | 'Mall' | 'Shop';
  selectedMenu: string;
  textItems: TextItems;
  imageItems: ImageItems;
  menuItems: MenuItem[];
  handleMenuClick: (id: string) => void;
  isMobile: boolean;
}

const IssueCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 80%;
  height: 80%;
  margin: 5% auto;
  padding: 10px;
  box-shadow: 5px 4px 20px 1px gray;
`;

const IssueCardMobile = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 95%;
  height: auto;
  margin: 2% auto;
  padding: 10px;
  box-shadow: 5px 4px 20px 1px gray;
`;

const IssueContent: React.FC<IssueContentProps> = ({
  type,
  selectedMenu,
  textItems,
  imageItems,
  menuItems,
  handleMenuClick,
  isMobile,
}) => {
  const CurrentIssueCard = isMobile ? IssueCardMobile : IssueCard;
  const theme = useTheme();

  return (
    <CurrentIssueCard>
      <Typography
        variant="h5"
        component="h2"
        gutterBottom
        textAlign={'center'}
        fontWeight={'500'}
      >
        {type === 'Hotel' ? '宿泊施設での活用' : type === 'Mall' ? '商業施設での活用' : '小売店での活用'}
      </Typography>
      <Divider sx={{ width: '80%', margin: '0 auto', borderWidth: '2px' }} />
      <CardContent
        sx={{
          width: '100%',
          height: '100%',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            marginLeft: '10px',
            [theme.breakpoints.down('md')]: {
              flexDirection: 'column',
              marginLeft: '0px',
            },
          }}
        >
          <DonutMenu items={menuItems} onItemClick={handleMenuClick} />
          <Box
            sx={{
              height: '100%',
              width: 'calc(100% - 400px)',
              margin: 'auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              marginLeft: '10px',
              [theme.breakpoints.down('md')]: {
                width: '100%',
                marginLeft: '0px',
                alignItems: 'center',
                textAlign: 'center',
              },
            }}
          >
            <Box>
              <Typography
                variant="h5"
                component="h5"
                gutterBottom
                textAlign={isMobile ? 'center' : 'left'}
                fontWeight={'500'}
              >
                {textItems[type][selectedMenu]?.title}
              </Typography>
              <Typography
                variant="h6"
                component="p"
                textAlign={isMobile ? 'center' : 'left'}
                gutterBottom
              >
                {textItems[type][selectedMenu]?.text.split('<br />').map((line, index) => (
                  <span key={index}>
                    {line}
                    {index < textItems[type][selectedMenu].text.split('<br />').length - 1 && <br />}
                  </span>
                ))}
              </Typography>
            </Box>
            <ImageList sx={{ width: '100%', height: '50%' }} variant="woven" cols={3} gap={8}>
              {
                imageItems[type][selectedMenu]?.map((item) => (
                  <ImageListItem key={item.img}>
                    <img
                      srcSet={`${item.img}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                      src={`${item.img}?w=164&h=164&fit=crop&auto=format`}
                      alt={item.title}
                      loading="lazy"
                      style={{ objectPosition: `${item.position}` }}
                    />
                  </ImageListItem>
                ))
              }
            </ImageList>
          </Box>
        </Box>
      </CardContent>
    </CurrentIssueCard>
  );
};

export default IssueContent;
